import React from 'react';
import PropTypes from 'prop-types';

import { PowerFunnelSurfaces } from '../../Analytics/constants';
import useFabletics from '../../hooks/useFabletics';
import FableticsControlBanner from './FableticsControlBanner';
import FableticsVersionOne from './FableticsVersionOne';
import FableticsVersionTwo from './FableticsVersionTwo';

const variantMap = {
    control: FableticsControlBanner,
    version_one: FableticsVersionOne,
    version_two: FableticsVersionTwo,
};

const FableticsBanner = ({ surface = PowerFunnelSurfaces.HOME }) => {
    const { enabled, variant } = useFabletics();
    if (!enabled) {
        return null;
    }
    const VariantComponent = variantMap[variant] || FableticsControlBanner;
    return <VariantComponent surface={surface} variant={variant} />;
};

FableticsBanner.propTypes = {
    surface: PropTypes.oneOf([PowerFunnelSurfaces.HOME, PowerFunnelSurfaces.POWER_PERKS_PAGE]),
};

FableticsBanner.defaultProps = {
    surface: PowerFunnelSurfaces.HOME,
};

export default FableticsBanner;
